export const FETCH_ACTIVE_CAMPAIGN = '@webapp/campaign/FETCH_ACTIVE_CAMPAIGN';
export const FETCH_ACTIVE_CAMPAIGN_SUCCESS = '@webapp/campaign/FETCH_ACTIVE_CAMPAIGN_SUCCESS';
export const FETCH_ACTIVE_CAMPAIGN_FAILURE = '@webapp/campaign/FETCH_ACTIVE_CAMPAIGN_FAILURE';
